import {CODY_APPLY_PAUSE} from "../../components/MxGraphBoard/PlayshotModal";
import {CodyResponse, CodyResponseType} from "../Cody";


export interface ApplyTask {
  name: string;
  func: () => Promise<CodyResponse>
}

export const makeApplyTask = (name: string, func: () => Promise<CodyResponse>): ApplyTask => {
  return {
    name,
    func
  }
}

export const runApplyTasks = async (tasks: ApplyTask[]): Promise<AsyncIterable<CodyResponse>> => {
  let lastResponseWasError = false;
  return {
    [Symbol.asyncIterator] () {
      return {
        async next() {
          const nextTask = tasks.shift();

          if(nextTask && !lastResponseWasError) {
            const res = await nextTask.func();

            lastResponseWasError = res.type === CodyResponseType.Error;

            return new Promise(resolve => {
              window.setTimeout(() => {
                resolve({done: false, value: res});
              }, tasks.length > 0 && res.type === CodyResponseType.Info || !res.type ? CODY_APPLY_PAUSE : 0);
            })
          } else {
            return new Promise((resolve) => {
              resolve({done: true, value: {
                cody: `All tasks applied!`
              }})
            })
          }
        }
      }
    }
  }
}
